export { default } from 'shared/components/popover'
